<script setup lang="ts">
  import { computed } from 'vue';

  interface ColorSetType {
    color_a: string;
    color_b: string;
    color_c: string;
  }

  const props = withDefaults(
    defineProps<{
      fullWhite?: boolean;
      fullBlack?: boolean;
      custom?: ColorSetType;
      onlyBrand?: boolean;
      width?: number;
      height?: number;
    }>(),
    {
      fullWhite: false,
      fullBlack: false,
      onlyBrand: false,
      custom: undefined,
      width: 166,
      height: 33,
    },
  );

  const colors = computed(() => {
    let color_a = '#F47920';
    let color_b = '#D71925';
    let color_c = '#999999';

    if (props.custom) {
      color_a = props.custom.color_a;
      color_b = props.custom.color_b;
      color_c = props.custom.color_c;
    }

    if (props.fullWhite) {
      color_a = '#FFF';
      color_b = '#FFF';
      color_c = '#FFF';
    }

    if (props.fullBlack) {
      color_a = '#53555c';
      color_b = '#53555c';
      color_c = '#53555c';
    }

    return {
      color_a,
      color_b,
      color_c,
    };
  });
</script>

<template>
  <svg
    class="cursor-pointer active:scale-95"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Logo"
      clip-path="url(#clip0_31_151)"
    >
      <g id="detail-orange">
        <path
          d="M11.6564 0.00268555V6.97738L28.2292 13.4034V6.49028L11.6564 0.00268555Z"
          :fill="colors.color_a"
        />
        <path
          d="M0.0292969 26.4214L16.5915 32.9973V26.0306L0.0292969 19.5083V26.4214Z"
          :fill="colors.color_a"
        />
      </g>
      <g id="detail-grey">
        <path
          d="M0 16.4813L13.5649 21.6146V14.8246L0 9.76617V16.4813Z"
          :fill="colors.color_c"
        />
        <path
          d="M28.2212 16.3555L16.0458 11.6664V18.4457L22.6393 21.0044L28.2212 16.3635V16.3555Z"
          :fill="colors.color_c"
        />
      </g>
      <g id="detail-red">
        <path
          d="M0.00311279 9.77153L5.5691 11.8779L11.6595 6.97202V0L0.00311279 9.77153Z"
          :fill="colors.color_b"
        />
        <path
          d="M16.5862 26.0334V33L28.2372 23.6647V16.3528L28.2212 16.3608L16.5862 26.0334Z"
          :fill="colors.color_b"
        />
      </g>
      <g
        id="scan"
        v-if="!onlyBrand"
      >
        <path
          d="M34.5565 20.4825L36.1536 18.0256C37.5724 19.056 39.0631 19.5966 40.2822 19.5966C41.3603 19.5966 41.8501 19.2032 41.8501 18.6117V18.5635C41.8501 17.7606 40.5777 17.493 39.1349 17.0407C37.3009 16.5054 35.2273 15.6409 35.2273 13.0849V13.0341C35.2273 10.3577 37.3754 8.85355 40.0187 8.85355C41.7597 8.87967 43.4563 9.40929 44.9059 10.3791L43.4898 12.9565C42.1934 12.1964 40.8971 11.7307 39.9442 11.7307C39.0391 11.7307 38.576 12.1241 38.576 12.6407V12.6888C38.576 13.4275 39.8217 13.7594 41.2378 14.2599C43.0665 14.8781 45.1934 15.7613 45.1934 18.1701V18.2183C45.1934 21.1436 43.0186 22.4711 40.1837 22.4711C38.1401 22.4564 36.1599 21.7566 34.5565 20.4825Z"
          :fill="colors.color_b"
        />
        <path
          d="M46.7266 15.7104V15.6623C46.7139 14.7542 46.8832 13.8528 47.2245 13.012C47.5657 12.1711 48.0719 11.408 48.7128 10.768C49.3537 10.1281 50.1163 9.62453 50.9549 9.28733C51.7936 8.95012 52.6912 8.7862 53.5943 8.80533C56.0645 8.80533 57.6031 9.64305 58.8249 11.016L56.549 13.473C55.7211 12.5924 54.8906 12.025 53.5703 12.025C51.707 12.025 50.3947 13.6737 50.3947 15.6141V15.6623C50.3947 17.6776 51.6884 19.2995 53.7194 19.2995C54.9651 19.2995 55.8196 18.7642 56.722 17.8997L58.8994 20.1104C57.627 21.5102 56.163 22.5192 53.5464 22.5192C52.65 22.5369 51.7593 22.3732 50.9271 22.0378C50.0949 21.7025 49.3382 21.2024 48.7021 20.5673C48.0659 19.9321 47.5632 19.1749 47.2238 18.3406C46.8845 17.5062 46.7154 16.6118 46.7266 15.7104Z"
          :fill="colors.color_b"
        />
        <path
          d="M60.0467 18.4404V18.3868C60.0467 15.5124 62.2241 14.1849 65.3252 14.1849C66.4128 14.1754 67.4937 14.3565 68.5194 14.7202V14.5007C68.5194 12.9511 67.5638 12.0919 65.7058 12.0919C64.4664 12.0942 63.239 12.3368 62.091 12.8065L61.1753 9.9642C62.7685 9.22936 64.5071 8.86875 66.2595 8.9097C68.2878 8.9097 69.7519 9.44498 70.6835 10.3817C71.6604 11.3666 72.0996 12.8146 72.0996 14.5837V22.2275H68.5061V20.7956C67.6037 21.7992 66.3553 22.4657 64.5479 22.4657C62.0803 22.4657 60.0493 21.0418 60.0493 18.4323L60.0467 18.4404ZM68.5673 17.5732V16.9202C67.8216 16.588 67.0138 16.4201 66.1983 16.4277C64.6011 16.4277 63.6322 17.0674 63.6322 18.245V18.2932C63.6322 19.3048 64.4627 19.899 65.6606 19.899C67.3961 19.899 68.5673 18.9408 68.5673 17.5893"
          :fill="colors.color_b"
        />
        <path
          d="M74.3223 9.05423H78.033V10.9277C78.8901 9.82235 79.9921 8.81335 81.8741 8.81335C84.6823 8.81335 86.3247 10.6868 86.3247 13.7058V22.2248H82.5981V14.8781C82.5981 13.109 81.7676 12.2017 80.3488 12.2017C78.93 12.2017 78.025 13.109 78.025 14.8781V22.2248H74.3223V9.05423Z"
          :fill="colors.color_b"
        />
      </g>
      <g
        id="source"
        v-if="!onlyBrand"
      >
        <path
          d="M88.0336 20.4825L89.6308 18.0256C91.0495 19.056 92.5375 19.5967 93.7593 19.5967C94.8241 19.5967 95.3219 19.2032 95.3219 18.6117V18.5636C95.3219 17.7606 94.0548 17.493 92.6121 17.0407C90.778 16.5054 88.6991 15.6409 88.6991 13.085V13.0341C88.6991 10.3577 90.8526 8.85359 93.4905 8.85359C95.2316 8.8788 96.9285 9.40849 98.3777 10.3791L96.9616 12.9565C95.6652 12.1964 94.3716 11.7307 93.4186 11.7307C92.5136 11.7307 92.0504 12.1241 92.0504 12.6407V12.6889C92.0504 13.4276 93.2962 13.7594 94.7123 14.2599C96.5463 14.8782 98.6705 15.7614 98.6705 18.1701V18.2183C98.6705 21.1436 96.4931 22.4711 93.6635 22.4711C91.6214 22.4545 89.6432 21.7538 88.0416 20.4799"
          :fill="colors.color_a"
        />
        <path
          d="M99.7166 15.7105V15.6623C99.7166 11.8806 102.746 8.80539 106.826 8.80539C110.907 8.80539 113.894 11.8297 113.894 15.6141V15.6623C113.894 19.4467 110.862 22.5219 106.779 22.5219C102.695 22.5219 99.7166 19.5003 99.7166 15.7105ZM110.226 15.7105V15.6623C110.226 13.7193 108.834 12.0251 106.779 12.0251C104.649 12.0251 103.382 13.6738 103.382 15.6141V15.6623C103.382 17.6054 104.774 19.2995 106.826 19.2995C108.956 19.2995 110.226 17.6536 110.226 15.7105Z"
          :fill="colors.color_a"
        />
        <path
          d="M115.507 17.584V9.05699H119.233V16.401C119.233 18.1728 120.061 19.0774 121.48 19.0774C122.899 19.0774 123.804 18.1701 123.804 16.401V9.05699H127.517V22.2276H123.793V20.3541C122.933 21.4567 121.834 22.4684 119.952 22.4684C117.141 22.4684 115.507 20.5949 115.507 17.576"
          :fill="colors.color_a"
        />
        <path
          d="M129.852 9.05427H133.578V11.7119C134.334 9.89198 135.556 8.71169 137.758 8.80804V12.7156H137.558C135.093 12.7156 133.578 14.2144 133.578 17.3618V22.2248H129.852V9.05427Z"
          :fill="colors.color_a"
        />
        <path
          d="M138.577 15.7105V15.6623C138.565 14.754 138.734 13.8524 139.075 13.0114C139.417 12.1703 139.923 11.4071 140.564 10.7671C141.206 10.1272 141.969 9.62363 142.807 9.28659C143.646 8.94954 144.544 8.78589 145.448 8.80539C147.915 8.80539 149.44 9.6431 150.678 11.0161L148.405 13.473C147.572 12.5925 146.739 12.0251 145.421 12.0251C143.558 12.0251 142.243 13.6738 142.243 15.6142V15.6623C142.243 17.6777 143.539 19.2996 145.567 19.2996C146.816 19.2996 147.67 18.7643 148.573 17.8998L150.75 20.1105C149.478 21.5103 148.011 22.5193 145.4 22.5193C144.503 22.5369 143.612 22.3732 142.78 22.0379C141.948 21.7026 141.191 21.2026 140.555 20.5675C139.918 19.9324 139.415 19.1752 139.076 18.3408C138.736 17.5065 138.566 16.612 138.577 15.7105Z"
          :fill="colors.color_a"
        />
        <path
          d="M151.189 15.7105V15.665C151.189 11.902 153.851 8.80804 157.666 8.80804C162.042 8.80804 164.054 12.2231 164.054 15.9594C164.054 16.2511 164.03 16.599 164.004 16.9389H154.873C155.238 18.6358 156.412 19.5217 158.068 19.5217C159.311 19.5217 160.218 19.1282 161.243 18.1835L163.373 20.0757C162.148 21.5985 160.391 22.5326 158.022 22.5326C154.085 22.5326 151.176 19.7545 151.176 15.7239L151.189 15.7105ZM160.413 14.6212C160.194 12.9484 159.218 11.8163 157.652 11.8163C156.087 11.8163 155.14 12.911 154.836 14.6105L160.413 14.6212Z"
          :fill="colors.color_a"
        />
      </g>
      <path
        id="&#194;&#174;"
        d="M162.787 8.79999C162.801 8.4857 162.906 8.18235 163.089 7.92758C163.273 7.67281 163.527 7.47785 163.819 7.36691C164.112 7.25597 164.431 7.23393 164.736 7.30353C165.041 7.37313 165.319 7.5313 165.536 7.7584C165.752 7.98551 165.898 8.27155 165.954 8.581C166.01 8.89046 165.975 9.20971 165.852 9.4991C165.729 9.7885 165.525 10.0353 165.264 10.2089C165.003 10.3824 164.697 10.4751 164.384 10.4754C164.17 10.4719 163.958 10.4257 163.761 10.3394C163.564 10.2532 163.387 10.1285 163.238 9.97271C163.089 9.8169 162.973 9.63304 162.896 9.43174C162.818 9.23045 162.781 9.01572 162.787 8.79999ZM164.384 10.1971C164.561 10.193 164.734 10.1534 164.895 10.0804C165.056 10.0074 165.201 9.90257 165.321 9.7722C165.44 9.64183 165.533 9.48857 165.592 9.32154C165.652 9.15452 165.677 8.97714 165.667 8.79999C165.681 8.62148 165.658 8.44199 165.6 8.27281C165.542 8.10363 165.449 7.94841 165.328 7.81692C165.207 7.68542 165.061 7.58049 164.898 7.50873C164.734 7.43697 164.558 7.39992 164.38 7.39992C164.202 7.39992 164.026 7.43697 163.863 7.50873C163.7 7.58049 163.553 7.68542 163.432 7.81692C163.311 7.94841 163.219 8.10363 163.16 8.27281C163.102 8.44199 163.079 8.62148 163.093 8.79999C163.085 8.97728 163.113 9.15437 163.174 9.32096C163.234 9.48754 163.328 9.64028 163.448 9.7703C163.568 9.90031 163.713 10.005 163.873 10.0783C164.034 10.1515 164.208 10.1919 164.384 10.1971ZM164.051 9.76617H163.785V7.84183H164.48C164.914 7.84183 165.13 8.00777 165.13 8.37711C165.135 8.44402 165.126 8.51126 165.105 8.57481C165.083 8.63835 165.049 8.69688 165.005 8.74688C164.96 8.79687 164.906 8.83731 164.846 8.86575C164.785 8.8942 164.72 8.91006 164.653 8.91239L165.185 9.75814H164.871L164.392 8.9231H164.075L164.051 9.76617ZM164.382 8.69561C164.616 8.69561 164.826 8.6742 164.826 8.37979C164.826 8.14427 164.618 8.11215 164.424 8.11215H164.051V8.70899L164.382 8.69561Z"
        :fill="colors.color_c"
      />
    </g>
    <defs>
      <clipPath id="clip0_31_151">
        <rect
          width="166"
          height="33"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
